import addRequestHeaders from './addRequestHeaders.js';
import passthrough from './passthrough.js';

function addExperimentOverridesHeader(experimentOverrides) {
    if (experimentOverrides) {
        return addRequestHeaders({ 'X-Deal-Experiment-Overrides': experimentOverrides });
    }
    else {
        return passthrough();
    }
}

export default addExperimentOverridesHeader;
//# sourceMappingURL=experimentOverrides.js.map
